import {defineAsyncComponent} from 'vue'

export const GlobalComponents = {
    // Helpers
    'pi-svg-icon': defineAsyncComponent(() => import('./SvgIconComponent.vue')),
    'pi-image-preview': defineAsyncComponent(() => import('./ImagePreviewComponent.vue')),
    'pi-image-preview-dialog': defineAsyncComponent(() => import('./ImagePreviewDialogComponent.vue')),

}
